import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a2ac8ee0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(["flex", [_ctx.buttonType, _ctx.buttonSize, { 'p-disabled': _ctx.isDisabled }, { active: _ctx.isActive }, _ctx.buttonStyle]]),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onButtonClick($event))),
    onMouseover: _cache[1] || (_cache[1] = ($event: any) => (_ctx.iconColorFillOver())),
    onMouseleave: _cache[2] || (_cache[2] = ($event: any) => (_ctx.iconColorFillLeave()))
  }, [
    (_ctx.iconName)
      ? (_openBlock(), _createElementBlock("i", {
          key: 0,
          class: _normalizeClass([_ctx.iconName, { 'mr-2': _ctx.buttonType !== 'icon' }])
        }, null, 2))
      : _createCommentVNode("", true),
    (_ctx.buttonType !== 'icon')
      ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_ctx.buttonText), 1))
      : _createCommentVNode("", true)
  ], 34))
}